import { Grip, Building2, Blocks } from 'lucide-react';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu';
import { getAppUrl } from '@/helpers/api';

const AppSwitcher = () => {
  const handleSwitchToAdmin = () => {
    window.location.href = getAppUrl('admin');
  };
  const handleSwitchToMega = () => {
    window.location.href = getAppUrl('mega');
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger>
        <Grip />
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuLabel>
          <p>App Switcher</p>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onClick={handleSwitchToAdmin}
          className="cursor-pointer"
        >
          <Building2 />
          Admin
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onClick={handleSwitchToMega}
          className="cursor-pointer"
        >
          <Blocks />
          Mega
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default AppSwitcher;
